import { render, staticRenderFns } from "./Tissue.vue?vue&type=template&id=6954f06f&scoped=true"
import script from "./Tissue.vue?vue&type=script&lang=js"
export * from "./Tissue.vue?vue&type=script&lang=js"
import style0 from "./Tissue.vue?vue&type=style&index=0&id=6954f06f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6954f06f",
  null
  
)

export default component.exports